module.exports = __webpack_public_path__ + "static/media/frame3.c5357f5c.jpg";